import { render, staticRenderFns } from "./QuestionarioParceiroComercial.vue?vue&type=template&id=5c428826&scoped=true"
import script from "./QuestionarioParceiroComercial.vue?vue&type=script&lang=js"
export * from "./QuestionarioParceiroComercial.vue?vue&type=script&lang=js"
import style0 from "./QuestionarioParceiroComercial.vue?vue&type=style&index=0&id=5c428826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c428826",
  null
  
)

export default component.exports